import { SET_LOGOUT } from './../actions';

export const clearState = (state = {}, action) => {
    switch(action.type) {
        case SET_LOGOUT:{
            state = [];
            return state;
        }
        default:
            return state;
    }
}